import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useLocalization } from '@/contexts/LocalizationContext'
import { Globe } from 'lucide-react'

const localeLabels: Record<string, string> = {
  en: 'US',
  ar: 'AR',
}

export function LanguageSwitcher() {
  const { locale, setLocale, t } = useLocalization()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-9 w-9">
          <span className="text-xs font-medium">{localeLabels[locale]}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => setLocale('en')}>
          <Globe className="me-2 h-4 w-4" />
          {t('language.english')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setLocale('ar')}>
          <Globe className="me-2 h-4 w-4" />
          {t('language.arabic')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
